import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { BRAND, NAV } from "../data/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border] duration-300 ${
        scrolled ? "bg-graphite/80 backdrop-blur-xl border-b border-white/10" : "border-b border-transparent"
      }`}
    >
      <nav className="container-pm flex items-center justify-between h-[72px]">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src={BRAND.logo} alt="PMPOINT" className="h-7 w-auto" width="140" height="28" />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.replace("#", "")}`}
              className="text-sm text-mutedfg hover:text-white transition-colors relative group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-coral transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#aplikuj"
            data-testid="nav-cta-apply"
            className="hidden sm:inline-flex items-center h-11 px-5 rounded-lg bg-coral text-white text-sm font-bold hover:bg-coral-hover hover:-translate-y-0.5 transition-all"
          >
            Sprawdź model współpracy
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-graphite/95 backdrop-blur-xl border-b border-white/10"
          >
            <div className="container-pm py-6 flex flex-col gap-4">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="text-base text-white/90 py-1"
                  data-testid={`nav-mobile-${item.href.replace("#", "")}`}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#aplikuj"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex justify-center items-center h-12 rounded-lg bg-coral text-white font-bold"
              >
                Sprawdź model współpracy
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
